import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngFooterComponent } from './kng-footer.component';
import { KngFooterService } from './kng-footer.service';
import { SafeHtmlPipe } from '../pipes/safehtml/safehtml.pipe';

@NgModule({
	declarations: [ KngFooterComponent, SafeHtmlPipe ],
	imports: [CommonModule],
	exports: [KngFooterComponent],
	providers: [KngFooterService]
})
export class KngFooterModule {}
